import Components from "slotworks/components/components";
import Contract from "slotworks/utils/contract";

export function JumpstartSpinCommand(): Contract<void> {
    return Components.matrix.startTransition(true);
}



// WEBPACK FOOTER //
// ./~/slotworks/commands/comms/jumpstart-spin-command.ts